/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Src_WebInputs */

const en_funnel_src_web = /** @type {(inputs: Funnel_Src_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web page`)
};

const es_funnel_src_web = /** @type {(inputs: Funnel_Src_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página web`)
};

/**
* | output |
* | --- |
* | "Web page" |
*
* @param {Funnel_Src_WebInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_src_web = /** @type {((inputs?: Funnel_Src_WebInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Src_WebInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_src_web(inputs)
	return en_funnel_src_web(inputs)
});